import { RiyalImgBLK } from '../../components/common/RiyalImg';
import { RiyalImgWHT } from '../../components/common/RiyalImg';
import BookSampleImg from "../../assets/defaults/BookSample-1.png";
import DeleteBtn from '../../components/buttons/DeleteBtn';
import PropTypes from 'prop-types';

const CartBooksItems = ({ handleOnClick, bookTitle, bookImg, bookImgAlt, bookPrice, bookQty, t }) => (
    <div className="book-container mt-2 px-2 position-relative">
        <DeleteBtn
            handleOnClick={handleOnClick}
            t={t}
        />

        <img
            crossOrigin="anonymous"
            src={bookImg ? bookImg : BookSampleImg}
            alt={bookImgAlt}
            className="rounded-2 w-100" />
        <div className="pt-1">
            <p className="text-white">{bookTitle} <br />
                <span>{bookPrice}<RiyalImgWHT /></span>{bookQty > 1 && <span> &#10005; {bookQty} {t("Book")}</span>}
            </p>
        </div>
    </div>
);

CartBooksItems.propTypes = {
    handleOnClick: PropTypes.func.isRequired,
    bookTitle: PropTypes.string.isRequired,
    bookImg: PropTypes.string,
    bookImgAlt: PropTypes.string,
    bookPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    bookQty: PropTypes.number,
    t: PropTypes.func.isRequired
};

CartBooksItems.defaultProps = {
    bookImg: '',
    bookImgAlt: '',
    bookQty: 1
};

const CartOrdersItmes = ({ handleOnClick, orderService, orderPrice, t }) => (
    <div className="d-flex bg-dark-gray my-2 ms-2 col-11 col-md-9 rounded align-items-center p-2 position-relative">
        <span className="col-8 tw-bold">{orderService}</span>
        <span className="col text-center">{orderPrice}<RiyalImgBLK /></span>
        <DeleteBtn
            handleOnClick={handleOnClick}
            value="Rejected"
            t={t}
        />
    </div>
);

CartOrdersItmes.propTypes = {
    handleOnClick: PropTypes.func.isRequired,
    orderService: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
    orderPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    t: PropTypes.func.isRequired
};

export { CartBooksItems, CartOrdersItmes }